import { render, staticRenderFns } from "./Viewper.vue?vue&type=template&id=13e99efb&scoped=true"
import script from "./Viewper.vue?vue&type=script&lang=js"
export * from "./Viewper.vue?vue&type=script&lang=js"
import style0 from "./Viewper.vue?vue&type=style&index=0&id=13e99efb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e99efb",
  null
  
)

export default component.exports